import layout from "src/styles/layout.module.scss";

export default function NativeAppLayout({
  children,
}: {
  children: JSX.Element;
}): JSX.Element {
  return (
    <>
      <main className={layout.gridRoot}>{children}</main>
      <div id="portal" />
      <div id="overlay-portal" />
    </>
  );
}
